// extracted by mini-css-extract-plugin
export default {"categoryTitle":"MovieList_categoryTitle__dniqg","movieList":"MovieList_movieList__lSNKa","movieCard":"MovieList_movieCard__LKv3d","loadMore":"MovieList_loadMore__aBJe0"};